import React, { useState, useRef } from "react";
import ImagePreview from "./ImagePreview";
import HeaderLogo from "../../components/Logo/HeaderLogo";
import { addDefaultImg, handleConsoleError } from "../../utils/common-methods";
import { toast } from "react-toastify";

const ImageUpload = ({
  title,
  onUpload,
  maxSize,
  validTypes,
  isCover = false,
  imageURL,
}) => {
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(imageURL);
  const [errorMessage, setErrorMessage] = useState("");
  const hiddenFileInput = useRef(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    let newErrorMessage = "";
    if (file) {
      if (!validTypes.includes(file.type)) {
        newErrorMessage = `File "${
          file.name
        }" is not a valid image type. Allowed types: ${validTypes.join(", ")}`;
      } else if (file.size > maxSize) {
        newErrorMessage = `File "${
          file.name
        }" exceeds the maximum size of ${maxSize / (1024 * 1024)}MB.`;
      } else {
        const reader = new FileReader();

        reader.onloadend = () => {
          const img = new Image();
          img.src = reader.result;

          img.onload = () => {
            const { width, height } = img;
            if (width < 459 || height < 230) {
              newErrorMessage = `Image must be at least 459px by 230px, but this image is ${width}px by ${height}px.`;
            } else {
              setImage(file);
              setImagePreview(reader.result);
            }
            setErrorMessage(newErrorMessage);
          };
        };

        reader.readAsDataURL(file);
      }
    }
    setErrorMessage(newErrorMessage);
  };

  const handleUpload = async () => {
    if (image && onUpload) {
      const formData = new FormData();
      formData.append("image", image);

      try {
        await onUpload(formData);
        return formData;
      } catch (error) {
       const message= handleConsoleError(error);
        toast.error(error?.message|| message);
      }
    }
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  return (
    <section className="loginswallow">
      <div className="form-container" id="form-container">
        {/* width: "250px", */}
        <div style={{ textAlign: "center", margin: "auto auto" }}>
          <HeaderLogo></HeaderLogo>
        </div>
        <h5>Upload Image</h5>
        <p>Add pictures to your profile to highlight.</p>

        {imagePreview && (
          <div style={{ textAlign: "center" }}>
            <img
              src={imagePreview}
              width="100%"
              height="auto"
              alt="noimage"
              onError={addDefaultImg}
            ></img>
          </div>
        )}
        {errorMessage && <p className="text-danger mt-3">{errorMessage}</p>}
        <div style={{ margin: "20px", textAlign: "center" }}>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            ref={hiddenFileInput}
            style={{ display: "none" }}
            id="file-input"
          />
        </div>

        <hr></hr>

        <div style={{ marginTop: "10px", textAlign: "center" }}>
          <button
            className="button-upload"
            onClick={handleClick}
            style={{ width: "180px", marginRight: "10px" }}
          >
            Select a file
          </button>

          {image && (
            <button onClick={handleUpload} style={{ width: "180px" }}>
              Upload Image
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ImageUpload;
